import { Pipe, PipeTransform } from '@angular/core';

import { IVehicleFullColumnSort } from '@src/app/interfaces/vehicle.interface';
import { sortByOrderId } from '@src/app/utils/common-fncs';

@Pipe({
  name: 'sortVehicleFullListColumns'
})
export class SortVehicleFullListColumnsPipe implements PipeTransform {

  transform(config: IVehicleFullColumnSort[], cols: any[]): any[] {
    if (!config?.length) {
      return cols;
    }
    const filterHiddenCols = cols.filter(col => {
      const configColumn = config.find(el => el.id === col.id);
      return configColumn ? configColumn.isVisible : true;
    });
    const sortedColumnsId = config.map(item => item.id);
    return sortByOrderId(sortedColumnsId, filterHiddenCols);
  }

}
